export class PreviousAddress {
    zip: string;
}